import { Component, OnInit, Optional, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import * as _ from 'lodash';

@Component({
  selector: 'esc-upload-column-error',
  templateUrl: './upload-column-error.component.html',
  styleUrls: ['./upload-column-error.component.scss']
})
export class UploadColumnErrorComponent implements OnInit {

  public title: string;
  public message: string;
  public hasCancel: boolean;
  public color: string;
  public button: string;
  public cancelButton: string;
  public extraButton: string;
  public expectedColumns;
  public columnsInFile;
  public extraButtonFn: () => void;

  constructor(
    public dialogRef: MatDialogRef<UploadColumnErrorComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.expectedColumns = _.get(this.data, 'expectedColumns');
    this.columnsInFile = _.get(this.data, 'columnsInFile');
    this.title = _.has(this.data, 'title') ? this.data.title : null;
    this.message = _.has(this.data, 'message') ? this.data.message : null;
    this.hasCancel = _.has(this.data, 'hasCancel') ? this.data.hasCancel : true;
    this.color = _.has(this.data, 'color') ? this.data.color : null;
    this.button = _.has(this.data, 'button') ? this.data.button : "OK";
    this.cancelButton = _.has(this.data, 'cancelButton') ? this.data.cancelButton : "Cancel";
    this.extraButton = _.has(this.data, 'extraButton') ? this.data.extraButton : null;
    this.extraButtonFn = _.has(this.data, 'extraButtonFn') && _.isFunction(this.data.extraButtonFn) ? this.data.extraButtonFn : () => {};
  }

}
